import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import {
  getInstagramCampaginRoutes,
  getInstagramRoutes,
  getOfferingAllSalesRoutes,
  getOfferingReportsRoutes,
  getOfferingRoutes,
  protected_routes,
} from "./routes";
import Home from "./Sidebar/Home";
import OnboardingMain from "./OnboardingPage/OnboardingMain";
import { SnackbarProvider } from "notistack";
import {
  INSTAGRAM,
  INSTAGRAM_CAMPAGINS,
  INSTAGRAM_CAMPAIGNS,
  ONBOARDING_INSTAGRAM_INTEGRATION,
  PAGES_ROUTE,
  REPORTS_ALL_SALES,
  REPORTS_ROUTE,
} from "./OnboardingPage/routeNames";
import theme from "./theme";
import { ThemeProvider } from "@mui/material";
import { LayoutProvider } from "./CustomHooks.js/LayoutContext";
import InstaDmIntegration from "./OnboardingPage/InstaDmIntegration";
import ChatMain from "./Chat/ChatMain";
import ChatSidebar from "./Chat/ChatSidebar";
import BusinessConsumerChat from "./Chat/BusinessConsumerChat";
function App() {
  // const [loading, setLoading] = useState()

  return (
    <ThemeProvider theme={theme}>
      <LayoutProvider>
        <SnackbarProvider
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          maxSnack={3}
          autoHideDuration={3000}
          hideIconVariant={true}
        >
          <BrowserRouter>
            <Routes>
              <Route path={"/onboarding"} element={<OnboardingMain />} />
              <Route
                path={ONBOARDING_INSTAGRAM_INTEGRATION}
                element={<InstaDmIntegration />}
              />
              <Route element={<ChatSidebar />}>
                <Route path="/chat" element={<ChatMain />} />
                <Route
                  path="/:businessId/chat"
                  element={<BusinessConsumerChat />}
                />
              </Route>
              <Route element={<Home />}>
                {protected_routes.map((route) => {
                  if (route.path === PAGES_ROUTE) {
                    return (
                      <Route path={PAGES_ROUTE} element={route.component}>
                        {getOfferingRoutes().map((route) => {
                          return (
                            <Route
                              path={route.path}
                              element={route.component}
                            />
                          );
                        })}
                      </Route>
                    );
                  } else if (route.path === REPORTS_ROUTE) {
                    return (
                      <Route path={REPORTS_ROUTE} element={route.component}>
                        {getOfferingReportsRoutes().map((route) => {
                          return (
                            <Route
                              path={route.path}
                              element={route.component}
                            />
                          );
                        })}
                      </Route>
                    );
                  } else if (route.path === REPORTS_ALL_SALES) {
                    return (
                      <Route path={REPORTS_ALL_SALES} element={route.component}>
                        {getOfferingAllSalesRoutes().map((route) => {
                          return (
                            <Route
                              path={route.path}
                              element={route.component}
                            />
                          );
                        })}
                      </Route>
                    );
                  } else if (route.path === INSTAGRAM_CAMPAIGNS) {
                    return (
                      <Route
                        path={INSTAGRAM_CAMPAIGNS}
                        element={route.component}
                      >
                        {getInstagramCampaginRoutes().map((route) => (
                          <Route path={route.path} element={route.component} />
                        ))}
                      </Route>
                    );
                  } else if (route.path === INSTAGRAM) {
                    return (
                      <Route path={INSTAGRAM} element={route.component}>
                        {getInstagramRoutes().map((route) => (
                          <Route path={route.path} element={route.component} />
                        ))}
                      </Route>
                    );
                  } else {
                    return (
                      <Route path={route.path} element={route.component} />
                    );
                  }
                })}
              </Route>
            </Routes>
          </BrowserRouter>
        </SnackbarProvider>
      </LayoutProvider>
    </ThemeProvider>
  );
}

export default App;
